import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { CueSendResult, CueStatusResponse, CueSyncResponse } from 'src/app/models/fincas/cue.model';
import { environment } from 'src/environments/environment';
import { CueExportPayloadBuilder } from 'src/app/view/app-common/modals/finca-cue-dialog/services/cue-export-payload.builder';

/** Encapsulates CUE HTTP calls so the modal does not own backend details. */
@Injectable({ providedIn: 'root' })
export class CueExportService {
  private readonly statusUrl = `${environment.serverUrl}ws/index.php?p1=fincas&p2=checkCUE`;

  private readonly sendUrl = `${environment.serverUrl}ws/index.php?p1=fincas&p2=sendCUE`;

  public constructor(
    private readonly http: HttpClient,
    private readonly payloadBuilder: CueExportPayloadBuilder,
  ) {}

  public checkStatus(finca: FincasModel): Observable<CueStatusResponse> {
    return this.http.post<CueStatusResponse>(this.statusUrl, this.payloadBuilder.buildStatusRequest(finca));
  }

  public send(finca: FincasModel): Observable<HttpResponse<CueSendResult>> {
    return this.http.post<CueSendResult>(this.sendUrl, this.payloadBuilder.buildSendRequest(finca), { observe: 'response' });
  }

  public syncStatus(finca: FincasModel, petitionCode: string): Observable<CueSyncResponse> {
    return this.http.post<CueSyncResponse>(this.statusUrl, this.payloadBuilder.buildSyncRequest(finca, petitionCode));
  }
}
